export default __webpack_public_path__ + "static/media/README.b30b148c.md";